import { render } from "./index.vue?vue&type=template&id=15dec6d1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=15dec6d1&lang=scss&scoped=scoped"
import "./index.vue?vue&type=style&index=1&id=15dec6d1&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dec6d1"]])

export default __exports__